// extracted by mini-css-extract-plugin
export var container = "_tz-0";
export var table = "_tz-2";
export var tableWrapper = "_tz-1";